module.exports = __webpack_public_path__ + "media/src/assets/Images/NotificationYellow-7c7df639facd43486f166618870afcf3.svg";